import { render } from "./disease-item.vue?vue&type=template&id=5acd5354&ts=true"
import script from "./disease-item.vue?vue&type=script&lang=ts"
export * from "./disease-item.vue?vue&type=script&lang=ts"

import "./disease-item.vue?vue&type=style&index=0&id=5acd5354&lang=scss"

import exportComponent from "C:\\Users\\Link\\Documents\\MCOM\\mcom-agri-origin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__